

import Vant from 'vant';
import { Toast } from 'vant';
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import service from "@/service/service";
import 'vant/lib/index.css'


const app = createApp(App);
app.provide('$axios', service);

//验证是否在微信浏览器
app.provide('$isWechat',() => {
    // 判断是否在微信中打开
    var ua = navigator.userAgent.toLowerCase();
    if(ua.match(/MicroMessenger/i)=="micromessenger") {
        console.log('在微信中打开')
        return true;
    } else {
        console.log('不在微信中打开')
        return false;
    }
})


//获取随机颜色16进制
app.provide('$getStrHex',(str) => {
    if (str == '') {
        return '';
    }
    let hex = '';
    for (let i = 0; i < str.length; i++) {
        hex += str.charCodeAt(i).toString(16);
    }

    //截取前6位
    hex = hex.substring(0,6);

    return hex;
})

//图片资源前缀
app.provide('image_url', 'https://apiapplet.xiangchao.ink/image');




app.use(Vant).use(Toast);


app.use(router).mount('#app');
